//gem

import { useEffect, useState } from "react";
import axios from "axios";
import API from "../api";

export default function Referrers() {
  const [grouped, setGrouped] = useState({});

  useEffect(() => {
    axios.get(`${API}/api/transactions`)
      .then(res => {
        const map = {};
        
        res.data.forEach(t => {
          // Identify the name field whether it's an object or an old unpopulated string ID
          let referrerName = "No Referrer";
          if (t.referrer && typeof t.referrer === "object") {
            referrerName = t.referrer.name || "Unknown Referrer";
          } else if (typeof t.referrer === "string") {
            referrerName = t.referrer; // Fallback to string ID for old records
          }

          if (!map[referrerName]) {
            map[referrerName] = { total: 0, count: 0 };
          }
          
          map[referrerName].total += t.amount;
          map[referrerName].count++;
        });
        
        setGrouped(map);
      });
  }, []);

  return (
    <div className="p-4 pb-20 bg-gray-50 min-h-screen">
      <h1 className="text-lg font-semibold mb-4">Referrers</h1>

      {Object.keys(grouped).map(name => (
        <div key={name} className="card mb-2 flex justify-between">
          <div>
            {/* Now cleanly prints out the plain textual name property */}
            <p className="font-medium">{name}</p> 
            <p className="text-sm text-gray-500">
              {grouped[name].count} transactions
            </p>
          </div>
          <p className="font-semibold">₹ {grouped[name].total}</p>
        </div>
      ))}
    </div>
  );
}